// Analytics for the search pages, recorded by the backend
// (analytics.models.TrackFilterSearchLog, SearchBoxSelectionLog and
// NaturalLanguageSearchLog).

// A visit ends after this long without a search.
export const VISIT_IDLE_MS = 30 * 60 * 1000
const STORAGE_KEY = 'sonata.searchVisit'

// A random id. crypto.randomUUID() only exists on secure origins (https,
// localhost), so plain-http development falls back to Math.random(), which is
// plenty to tell visits apart.
export function newSearchSession () {
  if (window.crypto && typeof window.crypto.randomUUID === 'function') {
    return window.crypto.randomUUID()
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = Math.floor(Math.random() * 16)
    return (c === 'x' ? r : (r % 4) + 8).toString(16)
  })
}

// Used when the browser won't let us store anything (some private modes).
let inMemory = null

// The id of this visit, so the backend can count a visit's several searches
// as one visit. Kept for the browser tab in sessionStorage, so Reload and
// Back stay in the same visit, and across both search pages; a new visit
// starts after VISIT_IDLE_MS without a search. Call it when sending a search
// or pick: each call counts as activity.
export function currentSearchSession (now = Date.now()) {
  let stored = inMemory
  try {
    stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY)) || stored
  } catch (error) {
    // Unreadable or unavailable: fall back to memory.
  }
  const id = stored && stored.id && now - stored.lastUsed < VISIT_IDLE_MS
    ? stored.id
    : newSearchSession()
  inMemory = { id, lastUsed: now }
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(inMemory))
  } catch (error) {
    // Kept in memory only.
  }
  return id
}
